export default __webpack_public_path__ + "static/media/wagerIcon.182fbebd.svg";